import { all, call, put, select, takeLatest } from "redux-saga/effects";
import pako from "pako";
import {
  apiGetCall,
  apiPatchCall,
  apiPostCall,
  apiPutCall,
  apiDeleteCall,
} from "../api";
import {
  getSelectedSeller,
  setSelectedSeller,
  setSellerStatus,
  setAllStatuses,
  getAllStatuses,
  setSearchedSellers,
  getSearchedSellers,
  patchApproveStatus,
  patchOnholdStatus,
  patchRejectStatus,
  setRejectionStatuses,
  getRejectionStatuses,
  setSelectedStatus,
  getContactTypes,
  setContactTypes,
  saveContactData,
  getCSVData,
  setRegistrationData,
  getRegistrationData,
  saveImplementationData,
  setReminderTypes,
  getReminderTypes,
  patchCertifiedStatus,
  patchBuildingStatus,
  resendInviteStart,
  resendInviteSuccess,
  resendInviteFailure,
  sellerProfileDelete,
  SELLER_STATUS_UPDATE_ACTIONS,
  startSellerStatusUpdate,
  setSellerStatusUpdateSuccess,
  setSellerStatusUpdateFailure,
} from "../slices/sellerSlice";
import {
  resetAppLoading,
  setAppLoading,
  setNotification,
} from "../slices/notificationSlice";
import axios from "axios";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import {
  getApiCredentialsContact,
  getQuestionnarie,
  postQuestionnarie,
  putQuestionnarie,
  setQuestionnarie,
  setApiCredentialsContact,
  putApiCredentialsContact,
  startQuestionnarieUpdate,
  setQuestionnarieUpdateSuccess,
  setQuestionnarieUpdateFailure,
} from "../slices/sellerDataSlice";
import {
  getUserAccessRequests,
  getUserStatus,
  putUserAccessRequest,
  setAfterActionUserData,
  setLoading,
  setUserAccessRequests,
  setUserStatus,
} from "../slices/userDataSlice";
import {
  getAllUserList,
  setAllUserList,
  getUserDetails,
  setUserDetails,
  getUserAccessAndLanguages,
  setUserAccessAndLanguages,
  getRoles,
  setRoles,
  putUserDetails,
  resetUserDetails,
  deleteUser,
  postNewUser,
  checkUser,
  setEmailCheck,
  setAdminCheck,
  checkAdmins,
  setAdminCheckUpdate,
  setUpdateBoxOpenForUser,
  setUserUpdateDetails,
  setNewUserDetails,
  setToggle,
} from "../slices/sellerDataUserListSlice";
import {
  getPostSellerUserForNotif,
  getPostSellerNotificationUser,
  getSellerNotificationAllUsers,
  getSellerNotificationTypes,
  putSellerNotificationUserData,
  setSellerNotificationAllUsers,
  setSellerNotificationTypes,
  setPostSellerUserForNotif,
} from "../slices/sellerNotificationSlice";

const URL = process.env.REACT_APP_API_URL;

function* checkTokenExpired() {
  // if (jwtDecode(token).exp < Date.now() / 1000) {
  yield window.instance
    .acquireTokenSilent({
      redirectUri: process.env.REACT_APP_AZURE_REDIRECT,
      authority: process.env.REACT_APP_AZURE_AUTHORITY,
    })
    .then((res) => {
      axios.defaults.headers.common["Authorization"] = `Bearer ${res.idToken}`;
    })
    .catch((e) => {
      if (e instanceof InteractionRequiredAuthError) {
        window.instance.loginRedirect();
      }
    });
  // window.instance
  //     .ssoSilent()
  //     .then((res) => {
  //       window.instance.setActiveAccount(res.account);
  //     })
  //     .catch((err) => {
  //       if (err instanceof InteractionRequiredAuthError) {
  //         window.instance.loginRedirect();
  //       }
  //     });
  // }
}

function* getSelectedSellerSaga(action) {
  try {
    // console.log('hehe')
    //   const token = yield call(getTokenSaga)
    //   console.log("paylod", token);

    yield call(checkTokenExpired);

    const data = yield call(
      apiGetCall,
      URL + "admin/profile/" + action.payload.id
    );

    yield put(setSelectedSeller(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch seller profile.",
        severity: "error",
        open: true,
      })
    );
  }
}

// An Onboarding seller is auto-promoted to Building by the backend once the user list,
// notification recipients and survey are all posted. Re-fetch the profile so the new
// status renders immediately instead of only after a manual page refresh.
function* refreshSellerIfOnboarding(sellerId) {
  const statusType = yield select(
    ({ seller }) => seller?.selectedSeller?.status_type
  );

  if (sellerId && statusType === "OB") {
    yield getSelectedSellerSaga({ payload: { id: sellerId } });
  }
}

function* setSelectedSellerSaga(action) {
  try {
    const data = yield call(
      apiPatchCall,
      URL + "sellers/" + action.payload.id,
      { ...action.payload }
    );
    if (data) {
      yield put(
        setNotification({
          message: "Seller updated successfully.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  }
}

function s2ab(s) {
  var buf = new ArrayBuffer(s.length);
  var view = new Uint8Array(buf);
  for (var i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
  return buf;
}

function* getCSVDataSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());

    // Get raw binary data from server
    const response = yield call(axios.get, `${URL}${"admin/download"}?statuses=${action.payload.data.join(',')}` ,{
      responseType: "arraybuffer",
    });

    const uint8Array = new Uint8Array(response.data);

    const isGzip = uint8Array[0] === 0x1f && uint8Array[1] === 0x8b;

    let finalData;

    if (isGzip) {
      const decompressed = pako.inflate(uint8Array);

      const base64String = new TextDecoder().decode(decompressed);
      finalData = s2ab(atob(base64String));
    } else {
      const base64String = new TextDecoder().decode(uint8Array);
      finalData = s2ab(atob(base64String));
    }

    const blob = new Blob([finalData], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "sellers.xlsx");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    action.payload.closeDropDown();

    yield put(
      setNotification({
        message: "File downloaded successfully",
        severity: "success",
        open: true,
      })
    );
  } catch (error) {
    console.error("Download error:", error);
    yield put(
      setNotification({
        message: `Download failed: ${error.message}`,
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getSearchedSellerSaga(action) {
  try {
    const state = yield select(({ seller: { currentStatus } }) => ({
      currentStatus,
    }));

    yield call(checkTokenExpired);

    yield put(
      setSearchedSellers({
        isInput: action.payload.isInput,
        loading: true,
        change: null,
        ...(action.payload.params?.searchTerm && {
          searchTerm: action.payload.params.searchTerm,
        }),
      })
    );
    const data = yield call(
      apiGetCall,
      `${URL}${"admin/profiles?"}${new URLSearchParams(
        action.payload.params
      ).toString()}`
    );

    // yield delay(5000);
    yield put(
      setSearchedSellers({
        ...data,
        isInput: action.payload.isInput,
        loading: false,
        change:
          action.payload.params.status === state.currentStatus ||
          action.payload.isInput,
      })
    );
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch sellers list.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getAllRejectionStatusesSaga() {
  try {
    yield call(checkTokenExpired);

    const data = yield call(apiGetCall, URL + "admin/rejection-reasons");
    yield put(setRejectionStatuses(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch rejection reasons.",
        severity: "error",
        open: true,
      })
    );
  }
}
function* getAllStatusesSaga() {
  try {
    yield call(checkTokenExpired);

    const data = yield call(apiGetCall, URL + "admin/statuses");

    yield put(setAllStatuses(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch seller statuses.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getApproveStatusSaga() {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);

    yield put(
      startSellerStatusUpdate({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.APPROVE,
      })
    );
    yield put(setAppLoading());

    const data = yield call(
      apiPatchCall,
      URL + `admin/status/${state.seller_id}?flag=S`,
      { status_type: "APA" }
    );

    if (data.status === "successful") {
      yield put(setSelectedStatus({ data: 0 }));
      yield put(
        setSellerStatusUpdateSuccess({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.APPROVE,
        })
      );
      yield getSelectedSellerSaga({ payload: { id: state.seller_id } });
    } else {
      yield put(
        setSellerStatusUpdateFailure({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.APPROVE,
        })
      );
    }
    yield put(
      setNotification({
        message:
          data.status === "successful"
            ? "Seller approved. Activation details will be sent to their email address."
            : "Something went wrong",
        severity: data.status === "successful" ? "success" : "error",
        open: true,
      })
    );
  } catch (error) {
    console.log(error);
    
    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );

    yield put(
      setSellerStatusUpdateFailure({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.APPROVE,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getCertifiedStatusSaga() {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);

    yield put(
      startSellerStatusUpdate({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.CERTIFY,
      })
    );
    yield put(setAppLoading());

    const data = yield call(
      apiPatchCall,
      URL + `admin/status/${state.seller_id}?flag=S`,
      { status_type: "CE" }
    );

    if (data.status === "successful") {
      yield put(setSelectedStatus({ data: 0 }));
      yield put(
        setSellerStatusUpdateSuccess({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.CERTIFY,
        })
      );
      yield getSelectedSellerSaga({ payload: { id: state.seller_id } });
    } else {
      yield put(
        setSellerStatusUpdateFailure({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.CERTIFY,
        })
      );
    }
    yield put(
      setNotification({
        message:
          data.status === "successful"
            ? "Seller certified."
            : "Something went wrong",
        severity: data.status === "successful" ? "success" : "error",
        open: true,
      })
    );
  } catch (error) {
    console.log(error);
   
    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );

     yield put(
      setSellerStatusUpdateFailure({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.CERTIFY,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}
function* getBuildingStatusSaga() {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);

    yield put(
      startSellerStatusUpdate({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.BUILD,
      })
    );
    yield put(setAppLoading());

    const data = yield call(
      apiPatchCall,
      URL + `admin/status/${state.seller_id}?flag=S`,
      { status_type: "BI" }
    );

    if (data.status === "successful") {
      yield put(setSelectedStatus({ data: 0 }));
      yield put(
        setSellerStatusUpdateSuccess({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.BUILD,
        })
      );
      yield getSelectedSellerSaga({ payload: { id: state.seller_id } });
    } else {
      yield put(
        setSellerStatusUpdateFailure({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.BUILD,
        })
      );
    }
    yield put(
      setNotification({
        message:
          data.status === "successful"
            ? "Seller moved to Building."
            : "Something went wrong",
        severity: data.status === "successful" ? "success" : "error",
        open: true,
      })
    );
  } catch (error) {
    console.log(error);

    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );

    yield put(
      setSellerStatusUpdateFailure({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.BUILD,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getOnholdStatusSaga(action) {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);

    yield put(
      startSellerStatusUpdate({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.ON_HOLD,
      })
    );
    yield put(setAppLoading());

    const data = yield call(
      apiPatchCall,
      URL + `admin/status/${state.seller_id}?flag=S`,
      { ...action.payload, status_type: "OH" }
    );

    if (data.status === "successful") {
      yield put(setSelectedStatus({ data: 0 }));
      yield put(
        setSellerStatusUpdateSuccess({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.ON_HOLD,
        })
      );
      yield getSelectedSellerSaga({ payload: { id: state.seller_id } });
    } else {
      yield put(
        setSellerStatusUpdateFailure({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.ON_HOLD,
        })
      );
    }
    yield put(
      setNotification({
        message:
          data.status === "successful"
            ? "Status changed to ‘On Hold’."
            : "Something went wrong",
        severity: data.status === "successful" ? "success" : "error",
        open: true,
      })
    );
  } catch (error) {
    console.log(error);
   
    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );

     yield put(
      setSellerStatusUpdateFailure({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.ON_HOLD,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getOnRejectStatusSaga(action) {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id, status_en },
        },
      }) => ({ seller_id, status_en })
    );

    yield call(checkTokenExpired);

    yield put(
      startSellerStatusUpdate({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.REJECT,
      })
    );
    yield put(setAppLoading());

    const flag = state.status_en === "Rejected" ? "RR" : "S";

    if (
      action.payload.status_type === "RJ" &&
      action.payload.rejection_reason.length
    ) {
      const data = yield call(
        apiPatchCall,
        URL + `admin/status/${state.seller_id}?flag=${flag}`,
        { ...action.payload }
      );

      if (data.status === "successful") {
        yield put(setSelectedStatus({ data: 0 }));
        yield put(
          setSellerStatusUpdateSuccess({
            actionType: SELLER_STATUS_UPDATE_ACTIONS.REJECT,
          })
        );
        yield getSelectedSellerSaga({ payload: { id: state.seller_id } });
      } else {
        yield put(
          setSellerStatusUpdateFailure({
            actionType: SELLER_STATUS_UPDATE_ACTIONS.REJECT,
          })
        );
      }
      yield put(
        setNotification({
          message:
            data.status === "successful"
              ? "Seller rejected. The seller will be notified of this update via email."
              : "Something went wrong",
          severity: data.status === "successful" ? "success" : "error",
          open: true,
        })
      );
    } else {
      
      yield put(
        setNotification({
          message: "Something went wrong",
          severity: "error",
          open: true,
        })
      );

      yield put(
        setSellerStatusUpdateFailure({
          actionType: SELLER_STATUS_UPDATE_ACTIONS.REJECT,
        })
      );
    }
  } catch (error) {
    console.log(error);
    
    yield put(
      setNotification({
        message: "Something went wrong",
        severity: "error",
        open: true,
      })
    );
    
    yield put(
      setSellerStatusUpdateFailure({
        actionType: SELLER_STATUS_UPDATE_ACTIONS.REJECT,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getContactTypesSaga() {
  try {
    yield call(checkTokenExpired);
    const { data } = yield call(apiGetCall, URL + "admin/contact-types");
    yield put(setContactTypes({ data }));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch contact types.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* postContactDataSaga(action) {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const data = yield call(
      action.payload.data.method === "put" ? apiPutCall : apiPostCall,
      URL + `admin/contact/${action.payload.data.id}`,
      { ...action.payload.data.formData }
    );
    if (data.status === "successful") {
      yield getSelectedSellerSaga({ payload: { id: state.seller_id } });
      yield put(
        setNotification({
          message: "Contact details updated.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getRegistrationDataSaga() {
  try {
    yield call(checkTokenExpired);
    const data = yield call(
      apiGetCall,
      URL + "admin/implementation-details-data"
    );

    yield put(setRegistrationData(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch implementation details.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* saveImplementationDataSaga(action) {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);

    yield put(setAppLoading());

    const data = yield call(
      apiPutCall,
      URL + `admin/implementation-details/${state.seller_id}`,
      action.payload.data
    );
    if (data.status === "successful") {
      yield getSelectedSellerSaga({ payload: { id: state.seller_id } });
      yield put(
        setNotification({
          message: "Profile updates saved.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getReminderTypesSaga() {
  try {
    yield call(checkTokenExpired);

    const { data } = yield call(apiGetCall, URL + `admin/reminder-types`);

    yield put(setReminderTypes({ data }));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch reminder types.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getQuestionnarieSaga(action) {
  try {
    yield call(checkTokenExpired);
    const data = yield call(
      apiGetCall,
      URL + `admin/survey-details/${action.payload.sellerId}`
    );

    yield put(setQuestionnarie(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch questionnaire details.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* postQuestionnarieSaga(action) {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);
    yield put(startQuestionnarieUpdate());
    yield put(setAppLoading());

    const apiUrl = URL + `admin/survey/${state.seller_id}`;

    const data = yield call(
      apiPostCall,
      apiUrl,
      action.payload.data
    );

    if (data?.status === "successful" || data?.data?.message === "Successful") {
      yield put(setQuestionnarieUpdateSuccess());
      yield put(getQuestionnarie({ sellerId: state.seller_id }));
      yield call(refreshSellerIfOnboarding, state.seller_id);
      yield put(
        setNotification({
          message: "Questionnaire submitted.",
          severity: "success",
          open: true,
        })
      );
    } else {
      yield put(setQuestionnarieUpdateFailure());
      yield put(
        setNotification({
          message: "Sorry, something went wrong.",
          severity: "error",
          open: true,
        })
      );
    }
  } catch (error) {
    yield put(setQuestionnarieUpdateFailure());
    yield put(
      setNotification({
        message: "Sorry, something went wrong.",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* putQuestionnarieSaga(action) {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);
    yield put(startQuestionnarieUpdate());
    yield put(setAppLoading());

    const apiUrl = URL + `admin/survey/${state.seller_id}`;

    const data = yield call(
      apiPutCall,
      apiUrl,
      action.payload.data
    );

    if (data?.status === "successful" || data?.data?.message === "Successful") {
      yield put(setQuestionnarieUpdateSuccess());
      yield put(getQuestionnarie({ sellerId: state.seller_id }));
      yield put(
        setNotification({
          message: "Questionnaire submitted.",
          severity: "success",
          open: true,
        })
      );
    } else {
      yield put(setQuestionnarieUpdateFailure());
      yield put(
        setNotification({
          message: "Sorry, something went wrong.",
          severity: "error",
          open: true,
        })
      );
    }
  } catch (error) {
    yield put(setQuestionnarieUpdateFailure());
    yield put(
      setNotification({
        message: "Sorry, something went wrong.",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getApiCredentialsContactSaga(action) {
  try {
    yield call(checkTokenExpired);
    const data = yield call(
      apiGetCall,
      URL + `admin/api-credentials-contact/${action.payload.sellerId}`
    );
    yield put(setApiCredentialsContact(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch API credentials contact.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* putApiCredentialsContactSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const data = yield call(
      apiPutCall,
      URL + `admin/api-credentials-contact/${action.payload.userId}`,
      { data: action.payload.data }
    );
    if (data.data.message === "Successful") {
      yield put(
        setNotification({
          message: "API contact credentials updated",
          severity: "success",
          open: true,
        })
      );
      const data  = yield call(
        apiGetCall,
        URL + `admin/api-credentials-contact/${action.payload.sellerId}`
      );
      yield put(setApiCredentialsContact(data));
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getUserAccessRequestSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setLoading({ loading: true }));
    const data = yield call(
      apiGetCall,
      URL +
        `admin/user-access-requests?${new URLSearchParams(
          action.payload.params
        ).toString()}`
    );
    //need to add Offset
    yield put(
      setUserAccessRequests({ data: data.users, change: action.payload.change })
    );
    yield put(setLoading({ loading: false }));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch user access requests.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getUserStatusSaga(action) {
  try {
    yield call(checkTokenExpired);
    const data = yield call(
      apiGetCall,
      URL +
        `admin/user-access-status${new URLSearchParams(
          action.payload.params
        ).toString()}`
    );
    yield put(setUserStatus({ data: data }));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch user status.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* putUserAccessRequestSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const data = yield call(
      apiPutCall,
      URL + `admin/user-access-request/${action.payload.data.id}`,
      { domain_status_id: action.payload.data.domain_status_id }
    );
    if (data.status === "Successful") {
      yield put(
        setAfterActionUserData({
          id: action.payload.data.id,
          option: action.payload.data.currentOption,
        })
      );
      // yield getUserAccessRequestSaga({ payload: { id: action.payload.data.id } });
      yield put(
        setNotification({
          message:
            action.payload.data.domain_status_id === "DS002"
              ? "User approved."
              : "User rejected. They can still be approved from the rejected user list.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getAllUsersSaga(action) {
  try {
    yield call(checkTokenExpired);

    const data = yield call(
      apiGetCall,
      URL + `admin/user-list-contacts/${action.payload.seller_id}`,
      { params: action.payload.params }
    );

    yield put(setAllUserList(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch users list.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getSellerNotificationSaga(action) {
  try {
    yield call(checkTokenExpired);
    const data = yield call(apiGetCall, URL + `admin/notification-types`);
    yield put(setSellerNotificationTypes({ data }));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch notification types.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getSellerNotificationAllUsersSaga(action) {
  try {
    yield call(checkTokenExpired);
    const data = yield call(
      apiGetCall,
      URL +
        `admin/notification-list-contacts/${action.payload.seller_id}?filter=${action.payload.filter}`
    );
    yield put(setSellerNotificationAllUsers({ data }));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch notification recipients.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* putSellerNotificationUserDataSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const data = yield call(
      apiPutCall,
      URL + `admin/notification-list-contact/${action.payload.user_id}`,
      { user_opted_notifications: action.payload.data }
    );
    if (data.status === "successful") {
      yield getSellerNotificationAllUsersSaga({
        payload: {
          seller_id: action.payload.seller_id,
          filter: action.payload.filter,
        },
      });
      yield put(
        setNotification({
          message: !action.payload.data.length
            ? "Recipient removed from all notifications."
            : "Recipient notifications updated.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getPostSellerNotificationUserSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());
    const data = yield call(
      apiPostCall,
      URL + `admin/notification-list-contact/${action.payload.seller_id}`,
      action.payload.data
    );
    if (data.status === "successful") {
      yield getSellerNotificationAllUsersSaga({
        payload: {
          seller_id: action.payload.seller_id,
          filter: action.payload.filter,
        },
      });
      yield call(refreshSellerIfOnboarding, action.payload.seller_id);
      yield put(
        setNotification({
          message: "New recipient added.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* getPostSellerUserForNotifSaga(action) {
  try {
    yield call(checkTokenExpired);
    const data = yield call(
      apiGetCall,
      URL +
        `admin/email-check/${action.payload.seller_id}?flag=ED&user_email=${action.payload.searchTerm}`
    );
    yield put(setPostSellerUserForNotif({ data }));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to validate email.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getUserDetailsSaga(action) {
  try {
    const state = yield select(({ sellerDataUserList: { open } }) => ({
      open,
    }));

    if (state.open !== action.payload.index) {
      yield call(checkTokenExpired);
      const data = yield call(
        apiGetCall,
        URL + `admin/user-list-contact/${action.payload.user_id}`
      );
      yield put(resetUserDetails());
      yield put(setUpdateBoxOpenForUser(action.payload.index));
      yield put(setUserDetails(data));
    } else yield put(setUpdateBoxOpenForUser(action.payload.index));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch user details.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getUserAccessAndLanguagesSaga() {
  try {
    yield call(checkTokenExpired);
    const data = yield call(apiGetCall, URL + `admin/user-list-details`);
    yield put(setUserAccessAndLanguages(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch user access and languages.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* getRolesSaga() {
  try {
    yield call(checkTokenExpired);
    const data = yield call(apiGetCall, URL + `admin/roles`);
    yield put(setRoles(data));
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to fetch roles.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* putUserDetailsSaga(action) {
  try {
    yield call(checkTokenExpired);
    // const state = yield select(({ sellerDataUserList }) => ({
    //   sellerDataUserList,
    // }));

    yield put(setAppLoading());

    const data = yield call(
      apiPutCall,
      URL + `admin/user-list-contact/${action.payload.user_id}`,
      action.payload.userData
    );

    if (data.status === "successful") {
      // yield put(reset());
      yield put(setToggle());
      yield put(
        setNotification({
          message: "User updated.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(setToggle());
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* deleteUserSaga(action) {
  try {
    yield call(checkTokenExpired);

    const data = yield call(
      apiDeleteCall,
      URL + `admin/user-list-contact/${action.payload.user_id}`
    );

    if (data.status === "successful") {
      // yield put(reset());
      yield put(setToggle());
      yield put(
        setNotification({
          message: "User removed.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(setToggle());
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  }
}

function* postNewUserSage(action) {
  try {
    yield call(checkTokenExpired);

    yield put(setAppLoading());

    const data = yield call(
      apiPostCall,
      URL + `admin/user-list-contact/${action.payload.seller_id}`,
      action.payload.userData
    );

    if (data.status === "successful") {
      // yield put(reset());
      yield put(setToggle());
      yield call(refreshSellerIfOnboarding, action.payload.seller_id);
      yield put(
        setNotification({
          message: data.user_approved
            ? "User created."
            : "User created. Their access is currently pending and they will be notified when approved.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(setToggle());
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* checkUserSaga(action) {
  try {
    yield call(checkTokenExpired);
    const state = yield select(
      ({ sellerDataUserList: { userUpdateDetails, newUser } }) => ({
        userUpdateDetails,
        newUser,
      })
    );

    const data = yield call(
      apiGetCall,
      URL +
        `admin/email-check/${action.payload.seller_id}?flag=${action.payload.flag}&user_email=${action.payload.user_email}`
    );

    if (data.Status === "Success" && action.payload.type === "add") {
      if (action.payload.flag === "EC") {
        yield put(setEmailCheck(data.emailExists));
      } else if (action.payload.flag === "AC") {
        yield put(
          setNewUserDetails({
            ...state.newUser,
            role: action.payload.data,
          })
        );
        yield put(setAdminCheck(data.adminsExist));
      }
    } else if (data.Status === "Success" && action.payload.type === "update") {
      yield put(
        setUserUpdateDetails({
          ...state.userUpdateDetails,
          role: action.payload.data,
        })
      );
      yield put(setAdminCheckUpdate(data.adminsExist));
    }
  } catch (error) {
    console.log(error);
    yield put(
      setNotification({
        message: "Unable to verify user details.",
        severity: "error",
        open: true,
      })
    );
  }
}

function* resendInvitationSaga(action) {
  try {
    yield call(checkTokenExpired);
    yield put(setAppLoading());

    const data = yield call(
      apiGetCall,
      URL + `admin/resend-reg-invite/${action.payload.seller_id}`
    );

    if (data.status === "successful") {
      yield put(resendInviteSuccess(data));
      yield put(
        setNotification({
          message: "Invitation resent.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.log(error);
    yield put(resendInviteFailure(error));
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* sellerProfileDeleteSaga(action) {
  try {
    const state = yield select(
      ({
        seller: {
          selectedSeller: { seller_id },
        },
      }) => ({ seller_id })
    );

    yield call(checkTokenExpired);

    yield put(setAppLoading());

    const data = yield call(
      apiDeleteCall,
      URL + `admin/seller-profile/${state.seller_id}`
    );

    if (data.status === "Successful") {
      action.payload.navigate();
      yield put(
        setNotification({
          message: "Profile deleted successfully.",
          severity: "success",
          open: true,
        })
      );
    }
  } catch (error) {
    console.error(error);
    yield put(
      setNotification({
        message: "Something went wrong. Try again!",
        severity: "error",
        open: true,
      })
    );
  } finally {
    yield put(resetAppLoading());
  }
}

function* sagas() {
  yield all([
    // takeLatest(fetchSellers.type, getAllSellersSaga),
    takeLatest(getSelectedSeller.type, getSelectedSellerSaga),
    takeLatest(getRejectionStatuses.type, getAllRejectionStatusesSaga),
    takeLatest(setSellerStatus.type, setSelectedSellerSaga),
    takeLatest(getAllStatuses.type, getAllStatusesSaga),
    takeLatest(getSearchedSellers.type, getSearchedSellerSaga),
    takeLatest(patchApproveStatus.type, getApproveStatusSaga),
    takeLatest(patchCertifiedStatus.type, getCertifiedStatusSaga),
    takeLatest(patchBuildingStatus.type, getBuildingStatusSaga),
    takeLatest(patchOnholdStatus.type, getOnholdStatusSaga),
    takeLatest(patchRejectStatus.type, getOnRejectStatusSaga),
    takeLatest(getContactTypes.type, getContactTypesSaga),
    takeLatest(saveContactData.type, postContactDataSaga),
    takeLatest(getCSVData.type, getCSVDataSaga),
    takeLatest(getRegistrationData.type, getRegistrationDataSaga),
    takeLatest(saveImplementationData.type, saveImplementationDataSaga),
    takeLatest(getReminderTypes.type, getReminderTypesSaga),
    takeLatest(getQuestionnarie.type, getQuestionnarieSaga),
    takeLatest(postQuestionnarie.type, postQuestionnarieSaga),
    takeLatest(putQuestionnarie.type, putQuestionnarieSaga),
    takeLatest(getApiCredentialsContact.type, getApiCredentialsContactSaga),
    takeLatest(putApiCredentialsContact.type, putApiCredentialsContactSaga),
    takeLatest(getUserAccessRequests.type, getUserAccessRequestSaga),
    takeLatest(getUserStatus.type, getUserStatusSaga),
    takeLatest(putUserAccessRequest.type, putUserAccessRequestSaga),

    takeLatest(getAllUserList.type, getAllUsersSaga),
    takeLatest(getSellerNotificationTypes.type, getSellerNotificationSaga),
    takeLatest(
      getSellerNotificationAllUsers.type,
      getSellerNotificationAllUsersSaga
    ),
    takeLatest(
      putSellerNotificationUserData.type,
      putSellerNotificationUserDataSaga
    ),
    takeLatest(
      getPostSellerNotificationUser.type,
      getPostSellerNotificationUserSaga
    ),
    takeLatest(getPostSellerUserForNotif.type, getPostSellerUserForNotifSaga),
    takeLatest(getUserDetails.type, getUserDetailsSaga),

    takeLatest(getUserAccessAndLanguages.type, getUserAccessAndLanguagesSaga),
    takeLatest(getRoles.type, getRolesSaga),
    takeLatest(putUserDetails.type, putUserDetailsSaga),
    takeLatest(deleteUser.type, deleteUserSaga),
    takeLatest(postNewUser.type, postNewUserSage),
    takeLatest(checkUser.type, checkUserSaga),
    takeLatest(checkAdmins.type, checkUserSaga),
    takeLatest(resendInviteStart.type, resendInvitationSaga),
    takeLatest(sellerProfileDelete.type, sellerProfileDeleteSaga),
  ]);
}

export default sagas;
